import styled, { css } from 'styled-components';
import { Space } from 'antd';

export const StyledSpace = styled(Space)<{ disabled?: boolean }>`
  ${({ disabled }) => {
    if (disabled) {
      return css`
        opacity: 0.4;
        cursor: not-allowed;
      `;
    }
    return;
  }}
`;
